module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar-title', {
    staticClass: "ml-0 pl-3",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('span', {
    staticClass: "pl-1"
  }), _vm._v(" "), _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$emit('toggle-drawer')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "white--text hidden-md-and-down",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("MeYouSeek\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04120784","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader/TheHeaderLogo.vue
// module id = 338
// module chunks = 0